/* Zen & Zip — homepage hero ambient video
   The hero <video> only loads on wider viewports, when the visitor hasn't
   asked for reduced motion, and when they're not on a metered/slow
   connection (navigator.connection.saveData). It stays at opacity:0 (see
   zz-rebrand.css) until it actually starts playing, so any skip, block, or
   load failure just leaves the static hero image showing underneath --
   no separate error handling needed. */
(function () {
  function eligible() {
    if (window.matchMedia('(max-width: 700px)').matches) return false;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
    if (navigator.connection && navigator.connection.saveData) return false;
    return true;
  }

  function init() {
    var video = document.querySelector('.zz-home__hero-video[data-src]');
    if (!video || !eligible()) return;

    video.addEventListener('playing', function () {
      video.classList.add('is-playing');
    });

    video.src = video.getAttribute('data-src');
    video.load();
    var playPromise = video.play();
    if (playPromise && playPromise.catch) playPromise.catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
